'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var formatTypes = ['uppercase', 'lowercase', 'int', 'alpha', 'alpha-spaces', 'alpha-int', 'currency', 'number-with-comma', 'no-spaces'];
var format = function format(formatType, value) {
  if (typeof value === 'undefined') return value;
  switch (formatType) {
    case 'uppercase':
      {
        return value.toUpperCase();
      }
    case 'lowercase':
      {
        return value.toLowerCase();
      }
    case 'int':
      {
        return value.replace(/[^0-9]/g, '');
      }
    case 'alpha':
      {
        return value.replace(/[^a-zA-Z]/g, '');
      }
    case 'alpha-spaces':
      {
        return value.replace(/[^a-zA-Z\s]/g, '');
      }
    case 'alpha-int':
      {
        return value.replace(/[^a-zA-Z0-9]/g, '');
      }
    case 'no-spaces':
      {
        return value.replace(/ /g, '');
      }
    case 'currency':
      {
        var valueToFormat = value;
        if (typeof value !== 'number') {
          valueToFormat = parseFloat(value, 10);
        }
        valueToFormat = valueToFormat.toFixed(2).replace(/./g, function (match, offset, str) {
          return offset && match !== '.' && (str.length - offset) % 3 === 0 ? ',' + match : match;
        });
        return valueToFormat;
      }
    case 'number-with-comma':
      {
        var _valueToFormat = value.toString();
        return _valueToFormat.replace(/./g, function (match, offset, str) {
          return offset && match !== '.' && (str.length - offset) % 3 === 0 ? ',' + match : match;
        });
      }
    default:
      {
        return value;
      }
  }
};
var wrapper = function wrapper(formatType, value) {
  var valueToFormat = value;
  if (Array.isArray(formatType)) {
    formatType.forEach(function (item) {
      valueToFormat = format(item, valueToFormat);
    });
  } else {
    valueToFormat = format(formatType, valueToFormat);
  }
  return valueToFormat;
};
exports.default = wrapper;

// extra methods

var min = function min(value, minimum) {
  return value >= minimum ? value : minimum;
};
var max = function max(value, maximum) {
  return value <= maximum ? value : maximum;
};
var pluralise = function pluralise(num) {
  if (num > 1 || num === 0) {
    return 's';
  }
  return '';
};
var prefixZero = function prefixZero(num) {
  var number = ~~num;
  return '' + (number < 10 ? 0 : '') + number;
};
var completeYear = function completeYear(num) {
  var currentYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getFullYear();
  var number = ~~num;
  if (number > 99) {
    return number;
  }
  var shortYear = currentYear % 100;
  if (number <= shortYear + 10) {
    return currentYear - shortYear + number;
  }
  return currentYear - shortYear - 100 + number;
};
var createGoogleStreetviewLink = exports.createGoogleStreetviewLink = function createGoogleStreetviewLink(latitude, longitude) {
  return 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + latitude + ',' + longitude;
};
var createGoogleMapLink = exports.createGoogleMapLink = function createGoogleMapLink(latitude, longitude) {
  return 'https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude;
};
exports.min = min;
exports.max = max;
exports.pluralise = pluralise;
exports.prefixZero = prefixZero;
exports.completeYear = completeYear;
exports.formatTypes = formatTypes;